const buildOption = (
  description?: string | null,
  onClick: () => void | Promise<void> = () => {},
  title?: string | null,
) => ({ description, onClick, title });

const utils = { buildOption };
export default utils;
